import { useState, useEffect, useMemo } from "react";
import isBefore from "date-fns/isAfter";

import { getDuration } from "../utils/date";

const SECOND = 1000;

interface CountdownOptions {
  format?: (now: Date | number, endDate: Date | number) => string;
  onComplete?: () => void;
}

export function useCountdown(endDate: Date | number, { format = getDuration, onComplete }: CountdownOptions = {}) {
  const [now, setDate] = useState(new Date());

  useEffect(
    function undateTime() {
      const interval = setInterval(() => {
        const now = new Date();

        if (!isBefore(endDate, now)) {
          clearInterval(interval);
          onComplete?.();
          return;
        }

        setDate(new Date());
      }, SECOND);

      return () => {
        clearInterval(interval);
      };
    },
    [endDate, onComplete]
  );

  return useMemo(() => format(now, endDate), [format, now, endDate]);
}
